
define('text!templates/loader.html',[],function () { return '<div class="ajax-loader {{loaderContentClass}}" id="{{uid}}">\n\t<div class="{{loaderClass}}">\n\t\t<div class="spinner"></div>\n\t\t<div class="loader-text">{{loaderText}}</div>\n\t</div>\n</div>';});

